import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Sifu from "./pages/Sifu";
import Classes from "./pages/Classes";
import Schedule from "./pages/Schedule";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import WingChun from "./pages/WingChun";
import WingChunTopic from "./pages/WingChunTopic";
import Book from "./pages/Book";
import Reviews from "./pages/Reviews";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen flex flex-col relative">
          <Header />
          <main className="flex-1 relative z-10">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sifu" element={<Sifu />} />
              <Route path="/classes" element={<Classes />} />
              <Route path="/wing-chun" element={<WingChun />} />
              <Route path="/wing-chun/:slug" element={<WingChunTopic />} />
              <Route path="/book" element={<Book />} />
              <Route path="/reviews" element={<Reviews />} />
              <Route path="/schedule" element={<Schedule />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin-panel-wc" element={<Admin />} />
            </Routes>
          </main>
          <Footer />
          <Toaster theme="dark" position="top-center" richColors />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
